export const TYPE_ACCENT = {
  pensamiento: "var(--type-pensamiento)",
  relato: "var(--type-relato)",
  microrelato: "var(--type-microrelato)",
  poema: "var(--type-poema)",
};

const SUB_TO_TYPE = {
  Pensamientos: "pensamiento",
  Relatos: "relato",
  Microrelatos: "microrelato",
  Poemas: "poema",
};

export function accentForType(type) {
  return TYPE_ACCENT[type] || "var(--rincon-secondary)";
}

export function accentForSubcategory(subcategory) {
  const t = SUB_TO_TYPE[subcategory];
  return t ? TYPE_ACCENT[t] : "var(--rincon-secondary)";
}
